// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const createMembershipPayloadSchema = z.object({
  user: urlSchema,
  organization: urlSchema,
  queues: z.array(urlSchema),
});
